<template>
  <div id="accfee_main">
    <div class="fee-content">
      <!-- <div class="ui warning message">
        <i class="close icon"></i>
        <div class="header">Important Information!</div>Name: minimum_fee (NO_SPACE_LOWERCAP) , Description: Minimum Fee
      </div>-->
      <tt-loading type="pendulums" v-show="loading"/>
      <div v-show="!loading" class="ui cards view">
        <div v-for="(fee, index) in fees" :key="fee.id" class="card" @click="editable(fee.id)">
          <div class="content" v-if="editList.indexOf(fee.id) < 0">
            <template v-if="fee.constraits">
              <i
                v-if="fee.constraits.max || fee.constraits.mode || fee.constraits.currency"
                class="right floated braille icon"
                data-content="Hello. This is a small popup"
                data-variation="small"
              ></i>
            </template>
            <div class="header">{{fee.desc}}</div>
            <div class="meta">{{fee.id}}</div>
            <div class="description">{{fee.name}}</div>
          </div>
          <div class="content" v-else>
            <form
              :id="'formEdit_'+index"
              v-on:submit.prevent="editFee('formEdit_'+index, index, fee.id)"
              class="ui form edit"
              :data-vv-scope="'formEdit_'+index"
            >
              <div
                class="focused field required"
                :class="{'input': true, 'error': errors.has('formEdit_'+index+'.name')}"
              >
                <label>Name</label>
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  v-model="fee.name"
                  v-validate="'required'"
                  data-vv-validate-on="change"
                  v-on:keyup.enter="editFee('formEdit_'+index, index, fee.id)"
                >
              </div>
              <div
                class="field required"
                :class="{'input': true, 'error': errors.has('formEdit_'+index+'.currency')}"
              >
                <label>Currency</label>
                <select
                  class="ui fluid search dropdown"
                  v-model="fee.currency"
                  name="currency"
                  v-validate="'required'"
                  data-vv-validate-on="change"
                >
                  <option disabled value>Currency</option>
                  <template v-for="currency in currencies">
                    <option :value="currency" :key="currency.id">{{currency}}</option>
                  </template>
                </select>
              </div>
              <div
                class="field required"
                :class="{'input': true, 'error': errors.has('formEdit_'+index+'.amount')}"
              >
                <label>Amount</label>
                <input
                  type="text"
                  name="amount"
                  placeholder="Amount"
                  v-model="fee.amt"
                  v-validate="'required|decimal:2'"
                  data-vv-validate-on="change"
                  v-on:keyup.enter="editFee('form_'+index, index, fee.id)"
                >
              </div>
              <div
                class="field required"
                :class="{'input': true, 'error': errors.has('formEdit_'+index+'.description')}"
              >
                <label>Description</label>
                <input
                  type="text"
                  name="description"
                  placeholder="Description"
                  v-model="fee.desc"
                  v-validate="'required'"
                  v-on:keyup.enter="editFee('formEdit_'+index, index, fee.id)"
                >
              </div>
              <div class="ui section divider"></div>
              <div
                class="sixteen wide field"
                :class="{'input': true, 'error': errors.has('formEdit_'+index+'.constraits.max')}"
              >
                <label data-tooltip="To restrict a fee (Optional)">
                  Constraits
                  <i class="info circle icon"></i>
                </label>
                <input
                  type="text"
                  name="constraits.max"
                  placeholder="Max allowed to add"
                  v-model="fee.constraits.max"
                  v-validate="'min_value:1'"
                  data-vv-validate-on="change"
                  v-on:keyup.enter="editFee('formEdit_'+index, index, fee.id)"
                >
              </div>
              <div class="fields">
                <div class="eight wide field">
                  <select
                    class="ui fluid search dropdown"
                    name="constraits.mode"
                    v-model="fee.constraits.mode"
                  >
                    <option disabled value>Mode</option>
                    <option value="fixed">Fixed</option>
                    <option value="percent">Percent</option>
                  </select>
                </div>
                <div class="eight wide field">
                  <select
                    class="ui fluid search dropdown"
                    v-model="fee.constraits.currency"
                    name="constraits.currency"
                  >
                    <option disabled value>Currency</option>
                    <template v-for="currency in currencies">
                      <option :value="currency" :key="currency.id">{{currency}}</option>
                    </template>
                  </select>
                </div>
              </div>

              <button class="ui mini button teal" name="update">Update</button>
              <div
                class="ui mini button negative right floated cancel"
                v-on:click.stop="editable(fee.id)"
                @click.exact="editableRm(fee.id)"
              >Cancel</div>
            </form>
          </div>
        </div>
      </div>
      <transition name="fade">
        <div class="ui cards create">
          <template v-for="(DOM, index) in feeDOM">
            <div class="card" :key="DOM.id">
              <div class="content">
                <form
                  :id="'form_'+index"
                  v-on:submit.prevent="newFee('form_'+index, index)"
                  class="ui form"
                  :data-vv-scope="'form_'+index"
                >
                  <div
                    class="focused field required"
                    :class="{'input': true, 'error': errors.has('form_'+index+'.name')}"
                  >
                    <label>Name</label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Name"
                      v-model="DOM.name"
                      v-validate="'required'"
                      data-vv-validate-on="change"
                      v-on:keyup.enter="newFee('form_'+index, index)"
                    >
                  </div>
                  <div
                    class="field required"
                    :class="{'input': true, 'error': errors.has('form_'+index+'.currency')}"
                  >
                    <label>Currency</label>
                    <select
                      class="ui fluid search dropdown"
                      v-model="DOM.currency"
                      name="currency"
                      v-validate="'required'"
                      data-vv-validate-on="change"
                    >
                      <option disabled value>Currency</option>
                      <template v-for="currency in currencies">
                        <option :value="currency" :key="currency.id">{{currency}}</option>
                      </template>
                    </select>
                  </div>
                  <div
                    class="field required"
                    :class="{'input': true, 'error': errors.has('form_'+index+'.amount')}"
                  >
                    <label>Amount</label>
                    <input
                      type="text"
                      name="amount"
                      placeholder="Amount"
                      v-model="DOM.amt"
                      v-validate="'required|decimal:2'"
                      data-vv-validate-on="change"
                      v-on:keyup.enter="newFee('form_'+index, index)"
                    >
                  </div>
                  <div
                    class="field required"
                    :class="{'input': true, 'error': errors.has('form_'+index+'.description')}"
                  >
                    <label>Description</label>
                    <input
                      type="text"
                      name="description"
                      placeholder="Description"
                      v-model="DOM.desc"
                      v-validate="'required'"
                      data-vv-validate-on="change"
                      v-on:keyup.enter="newFee('form_'+index, index)"
                    >
                  </div>

                  <div class="ui section divider"></div>

                  <div
                    class="sixteen wide field"
                    :class="{'input': true, 'error': errors.has('form_'+index+'.constraits.max')}"
                  >
                    <label data-tooltip="To restrict a fee (Optional)">
                      Constraits
                      <i class="info circle icon"></i>
                    </label>
                    <input
                      type="text"
                      name="constraits.max"
                      placeholder="Max allowed to add"
                      v-model="DOM.con_max"
                      v-validate="'min_value:1'"
                      data-vv-validate-on="change"
                      v-on:keyup.enter="newFee('form_'+index, index)"
                    >
                  </div>
                  <div class="fields">
                    <div class="eight wide field">
                      <select
                        class="ui fluid search dropdown"
                        name="constraits.mode"
                        v-model="DOM.con_mode"
                      >
                        <option disabled value>Mode</option>
                        <option value="fixed">Fixed</option>
                        <option value="percent">Percent</option>
                      </select>
                    </div>
                    <div class="eight wide field">
                      <select
                        class="ui fluid search dropdown"
                        v-model="DOM.con_currency"
                        name="constraits.currency"
                      >
                        <option disabled value>Currency</option>
                        <template v-for="currency in currencies">
                          <option :value="currency" :key="currency.id">{{currency}}</option>
                        </template>
                      </select>
                    </div>
                  </div>

                  <button
                    class="ui mini button positive"
                    name="create"
                    :class="{'disabled loading': creatingList[index]}"
                  >Submit</button>
                  <div
                    class="ui mini button negative right floated remove"
                    @click="deleteFee"
                  >Remove</div>
                </form>
              </div>
            </div>
          </template>
        </div>
      </transition>
    </div>
    <!-- <div class="footer">
      <div class="ui clearing segment">
        <div
          class="ui right floated button primary"
          :class="{'disabled': publishing}"
          @click="publishFee"
        >
          <template v-if="publishing">Publishing</template>
          <template v-if="!publishing">Publish</template>
        </div>
        <div class="ui right floated button green" @click="addFee">Add Fee</div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { eventBus } from "@/main.js";

export default {
  name: "Acc_Fee",
  mounted() {
    this.init();
  },
  data() {
    return {
      fees: [],
      loading: 0,
      currencies: [],
      feeDOM: [],
      // publishing: 0,
      editList: []
    };
  },
  methods: {
    init() {

      eventBus.$emit('accFeeContext', 1);
      eventBus.$on('addFee', i => {
        this.addFee();
      });
      eventBus.$on('publishFee', j=> {
        this.publishFee();
      });
      // jQuery(".footer").sticky({
      //   context: "#accfee_main"
      // });
      jQuery(".ui.dropdown").dropdown();
      if (this.$store.state.acc_fees.length) {
        this.fees = this.$store.state.acc_fees;
        this.fees.sort((a,b) => a.desc.localeCompare(b.desc));

      } else {
        this.getFees();
      }
      this.getCurrencies();

      // jQuery(".fee-content .ui.cards.view .content i").popup();
    },
    getCurrencies() {
      if (this.$store.state.currencies.length) {
        this.currencies = this.$store.state.currencies;
      } else {
        const tempCurrencies = [];
        const url = `${process.env.VUE_APP_BACKEND_URL}/enum/currencies`;
        this.axios
          .get(url)
          .then(response => {
            if (response.status === 200 && response.data.items) {
              response.data.items.forEach(item => {
                tempCurrencies.push(item.alpha);
              });
              tempCurrencies.sort();
              this.currencies = tempCurrencies.filter(
                (item, index) => tempCurrencies.indexOf(item) >= index
              );
              this.$store.commit('mutate', {
                property: 'currencies',
                with: this.currencies });
            }
          })
          .catch(() => {})
          .finally(() => {});
      }
    },
    getFees() {
      this.fees = [];
      this.loading = 1;
      const url = `${process.env.VUE_APP_BACKEND_URL}/enum/fees`;
      let con_fees = [];
      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.items) {
            response.data.items.account.forEach(item => {
              this.fees.push(item);
            });
            response.data.items.contract.forEach(item => {
              con_fees.push(item);
            });

            this.fees.sort((a,b) => a.desc.localeCompare(b.desc));
            this.$store.commit('mutate', {
								property: 'con_fees',
                with: con_fees});
            this.$store.commit('mutate', {
								property: 'acc_fees',
								with: this.fees});
            this.loading = 0;
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
    addFee() {
      if (!this.feeDOM.length) {
        this.creatingList = [];
      }
      this.feeDOM.push({});
      this.creatingList.push(0);
      this.scrollToEnd();
    },
    deleteFee() {
      this.feeDOM.pop();
      this.creatingList.pop();
    },
    newFee(scope, i) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          if (this.feeDOM[i].name.split(" ").length > 1) {
            eventBus.$emit("statusMessage", {
              title: "Success (201)",
              content: this.feeDOM[i].name + " cannot contain whitespaces!",
              status: "custom_warn"
            });
          } else {
            jQuery("#form_" + i)
              .find("input")
              .prop("disabled", true);
            jQuery("#form_" + i)
              .find("select")
              .prop("disabled", true);
            jQuery("#form_" + i)
              .find('button[name="create"]')
              .prop("disabled", true);
            jQuery("#form_" + i)
              .find('button[name="create"]')
              .addClass("loading");
            jQuery("#form_" + i)
              .find(".ui.mini.button.remove")
              .addClass("disabled");

            const requestHeaders = {
              "Content-Type": "application/x-www-form-urlencoded"
            };
            const url = `${process.env.VUE_APP_BACKEND_URL}/enum/fees`;

            this.axios({
              method: "post",
              url,
              data: {
                name: this.feeDOM[i].name,
                currency: this.feeDOM[i].currency,
                amount: this.feeDOM[i].amt,
                description: this.feeDOM[i].desc,
                applicable: "account",
                constraits: {
                  max: this.feeDOM[i].con_max,
                  mode: this.feeDOM[i].con_mode,
                  currency: this.feeDOM[i].con_currency
                }
              },
              headers: requestHeaders
            })
              .then(response => {
                if (response.status === 200 && response.data.status) {
                  jQuery("#form_" + i)
                    .find('button[name="create"]')
                    .removeClass("loading");
                  eventBus.$emit("statusMessage", {
                    title: "Success (201)",
                    content:
                      this.feeDOM[i].name +
                      " has successfully created! <br/> Publish to see changes!",
                    status: "custom_success"
                  });
                } else {
                  jQuery("#form_" + i)
                    .find("input")
                    .prop("disabled", false);
                  jQuery("#form_" + i)
                    .find("select")
                    .prop("disabled", false);
                  jQuery("#form_" + i)
                    .find('button[name="create"]')
                    .prop("disabled", false);
                  jQuery("#form_" + i)
                    .find('button[name="create"]')
                    .removeClass("loading");
                  jQuery("#form_" + i)
                    .find(".ui.mini.button.remove")
                    .removeClass("disabled");
                  eventBus.$emit("statusMessage", {
                    title: "Failed",
                    content: this.feeDOM[i].name + " cannot be created!",
                    status: "custom_error"
                  });
                }
              })
              .catch(err => {
                console.error(err);
                jQuery("#form_" + i)
                  .find("input")
                  .prop("disabled", false);
                jQuery("#form_" + i)
                  .find("select")
                  .prop("disabled", false);
                jQuery("#form_" + i)
                  .find('button[name="create"]')
                  .prop("disabled", false);
                jQuery("#form_" + i)
                  .find('button[name="create"]')
                  .removeClass("loading");
                jQuery("#form_" + i)
                  .find(".ui.mini.button.remove")
                  .removeClass("disabled");
                eventBus.$emit("statusMessage", {
                  title: "Error!",
                  content: err,
                  status: "custom_error"
                });
              })
              .finally(() => {});
          }
        }
      });
    },
    editFee(scope, i, id) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          jQuery("#formEdit_" + i)
            .find("input")
            .prop("disabled", true);
          jQuery("#formEdit_" + i)
            .find("select")
            .prop("disabled", true);
          jQuery("#formEdit_" + i)
            .find('button[name="update"]')
            .prop("disabled", true);
          jQuery("#formEdit_" + i)
            .find('button[name="update"]')
            .addClass("loading");
          jQuery("#formEdit_" + i)
            .find(".ui.mini.button.cancel")
            .addClass("disabled");
          const requestHeaders = {
            "Content-Type": "application/x-www-form-urlencoded"
          };
          const url = `${process.env.VUE_APP_BACKEND_URL}/enum/fees/${id}`;

          this.axios({
            method: "post",
            url,
            data: {
              name: this.fees[i].name,
              currency: this.fees[i].currency,
              amount: this.fees[i].amt,
              description: this.fees[i].desc,
              applicable: "account",
              constraits: {
                max: this.fees[i].constraits.max,
                mode: this.fees[i].constraits.mode,
                currency: this.fees[i].constraits.currency
              }
            },
            headers: requestHeaders
          })
            .then(response => {
              if (response.status === 200 && response.data.status) {
                jQuery("#formEdit_" + i)
                  .find('button[name="update"]')
                  .removeClass("loading");
                eventBus.$emit("statusMessage", {
                  title: "Success (200)",
                  content:
                    this.fees[i].name +
                    " has successfully updated! Publish to see changes!",
                  status: "custom_success"
                });
              } else {
                jQuery("#formEdit_" + i)
                  .find("input")
                  .prop("disabled", false);
                jQuery("#formEdit_" + i)
                  .find("select")
                  .prop("disabled", false);
                jQuery("#formEdit_" + i)
                  .find('button[name="update"]')
                  .prop("disabled", false);
                jQuery("#formEdit_" + i)
                  .find('button[name="update"]')
                  .removeClass("loading");
                jQuery("#formEdit_" + i)
                  .find(".ui.mini.button.cancel")
                  .removeClass("disabled");
                eventBus.$emit("statusMessage", {
                  title: "Failed",
                  content: this.fees[i].name + " cannot be updated!",
                  status: "custom_error"
                });
              }
            })
            .catch(err => {
              console.error(err);
              jQuery("#formEdit_" + i)
                .find("input")
                .prop("disabled", false);
              jQuery("#formEdit_" + i)
                .find("select")
                .prop("disabled", false);
              jQuery("#formEdit_" + i)
                .find('button[name="update"]')
                .prop("disabled", false);
              jQuery("#formEdit_" + i)
                .find('button[name="update"]')
                .removeClass("loading");
              jQuery("#formEdit_" + i)
                .find(".ui.mini.button.cancel")
                .removeClass("disabled");
              eventBus.$emit("statusMessage", {
                title: "Error!",
                content: err,
                status: "custom_error"
              });
            })
            .finally(() => {});
        }
      });
    },
    publishFee() {
      // this.publishing = 1;
      const url = `${process.env.VUE_APP_BACKEND_URL}/enum/publish`;
      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200) {
            this.editList = [];
            eventBus.$emit("statusMessage", {
              title: "Success (200)",
              content: "Fees have published!",
              status: "custom_success"
            });
            this.feeDOM = [];
            this.getFees();
          } else {
            eventBus.$emit("statusMessage", {
              title: "Error",
              content: "Fees failed to publish!",
              status: "custom_error"
            });
          }
          eventBus.$emit('publishStatus', 0);
          // this.publishing = 0;
        })
        .catch(() => {
          eventBus.$emit('publishStatus', 0);
          // this.publishing = 0;
        })
        .finally(() => {});
    },
    scrollToEnd() {
      window.scrollTo(
        0,
        document.body.scrollHeight || document.documentElement.scrollHeight
      );
    },
    editable(id) {
      if (!this.editList.includes(id)) {
        this.editList.push(id);
      }
    },
    editableRm(id) {
      let index = this.editList.indexOf(id);

      if (index > -1) {
        this.editList.splice(index, 1);
      }
    }
  }
};
</script>

<style scoped>
.ui.cards.create {
  min-height: 400px;
}
.fee-content {
  margin: 42px 10px 100px 0;
  width: 70vw;
}
.ui.cards.view .card:hover {
  background-color: rgba(230, 230, 230, 0.5);
}
/* #accfee_main .footer.sticky {
  position: -webkit-sticky;
  position: sticky;
  bottom: 0 !important;
  width: 75%;
  box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.1);
  padding: 10px;
} */
</style>

